import { ReactElement } from 'react';
import { Component as RightArrowIcon } from 'icons/icon-ui--arrow-right-outline.svg';
import { Component as LeftArrowIcon } from 'icons/icon-ui--arrow-left-outline.svg';

import styles from '../ProductDisplayPage.module.scss';

type Props = {
  page: number;
  totalPages: number;
  startIndex: number;
  endIndex: number;
  totalReviews: number;
  onPrev: () => void;
  onNext: () => void;
};

export function ReviewsPagination({
  page,
  totalPages,
  startIndex,
  endIndex,
  totalReviews,
  onPrev,
  onNext,
}: Props): ReactElement {
  return (
    <div className={styles.reviews_pagination}>
      <button
        type="button"
        className={styles.pagination_arrow}
        onClick={onPrev}
        disabled={page === 1 || totalReviews === 0}
        aria-label="Previous page"
      >
        <LeftArrowIcon style={{ fill: 'white' }} />
      </button>
      <span className={styles.pagination_label}>
        {startIndex}
        -
        {endIndex}
        {' '}
        out of
        {' '}
        {totalReviews}
        {' '}
        {totalReviews === 1 ? 'review' : 'reviews'}
      </span>
      <button
        type="button"
        className={styles.pagination_arrow}
        onClick={onNext}
        disabled={page === totalPages || totalReviews === 0}
        aria-label="Next page"
      >
        <RightArrowIcon style={{ fill: 'white' }} />
      </button>
    </div>
  );
}
